import { useState } from 'react';
import AppHeader from '../../../components/AppHeader';
import FilterRadioButton from '../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../components/FilterRadioButtonsContainer';
import Loader from '../../../components/Loader';
import NoData from '../../../components/NoData';
import OpacityAnimation from '../../../components/OpacityAnimation';
import PageHeader from '../../../components/PageHeader';
import Sidebar from '../../../components/Sidebar';
import Transitions from '../../../components/Transition';
import { useAppContext } from '../../../contexts/auth';
import ActionsModal from './components/ActionsModal';
import RemoveFileModal from './components/RemoveFileModal';
import SearchByCodeModal from './components/SearchByCodeModal';
import SearchByCpfModal from './components/SearchByCpfModal';
import SearchByFileModal from './components/SearchByFileModal';
import SearchByNameModal from './components/SearchByNameModal';
import SearchByPeriodModal from './components/SearchByPeriodModal';
import SearchByRegistrationModal from './components/SearchByRegistrationModal';
import SearchByWorkplaceModal from './components/SearchByWorkplaceModal';
import SearchesTypes from './components/SearchesTypes';
import SendEmailsModal from './components/SendEmailsModal';
import TableView from './components/TableView';
import Filters from './components/filters';
import ListHeader from './components/header';
import ConsultsList from './components/list';
import useSearchConsult from './useSearchConsult';

export default function SearchConsult() {
  const {
    isLoading,
    companyCode,
    searchByCpfModalShow,
    setSearchByCpfModalShow,
    searchByCpf,
    fullConsults,
    filteredConsults,
    currentPage,
    pagesQuantity,
    handlePageChange,
    searchLabel,
    searchByCodeModalShow,
    setSearchByCodeModalShow,
    searchByCode,
    searchByNameModalShow,
    setSearchByNameModalShow,
    searchByName,
    searchByRegistrationModalShow,
    setSearchByRegistrationModalShow,
    searchByRegistration,
    searchByPeriodModalShow,
    setSearchByPeriodModalShow,
    searchByPeriod,
    workplacesOptions,
    searchByWorkplaceModalShow,
    setSearchByWorkplaceModalShow,
    searchByWorkplace,
    filesOptions,
    loadListsForSearching,
    searchByFileModalShow,
    setSearchByFileModalShow,
    searchByFile,
    selectedType,
    setSelectedType,
    isSelectingConsults,
    setIsSelectingConsults,
    selectedConsults,
    handleConsultSelection,
    clearAllSelectedConsults,
    addAllSelectedConsults,
    actionModalShow,
    setActionModalShow,
    selectedAction,
    setSelectedAction,
    confirmAction,
    routingStatus,
    routingStatusOptions,
    setRoutingStatus,
    consultStatus,
    consultStatusOptions,
    setConsultStatus,
    emailSendZip,
    handleEmailSendZipChange,
    removeFileModalShow,
    setRemoveFileModalShow,
    removeFile,
    isFileSearch,
    hasOpenedRequest,
    setSendEmailsModalShow,
    sendEmailsModalShow,
    sendEmails,
  } = useSearchConsult();

  const hasConsults = fullConsults?.length > 0;
  const filteredListLength = filteredConsults?.length;
  const [listView, setListView] = useState<'card' | 'table'>('card');
  const { isDifferentSubdomain } = useAppContext();

  return (
    <>
      <AppHeader isCompanySelectedDisabled={false} />
      <Sidebar active="SearchConsults"/>
      <Transitions>
        <Loader isLoading={isLoading} />
        <PageHeader title="Pesquisar Consultas" />

        {!companyCode && (
          <NoData
            icon="companyInterrogation"
            label={(
              <>
                Selecione uma empresa para pesquisar as consultas.
              </>
            )}
          />
        )}

        {!!companyCode && (
          <>
            <FilterRadioButtonsContainer>
              <FilterRadioButton selected={selectedType === 'preAdm'} onClick={() => setSelectedType('preAdm')}>
                Pré-Admissional (avulso) / Multirotas
              </FilterRadioButton>
              {!isDifferentSubdomain && (
                <FilterRadioButton selected={selectedType === 'base'} onClick={() => setSelectedType('base')}>
                  Gestão de Base
                </FilterRadioButton>
              )}
            </FilterRadioButtonsContainer>

            <div style={{ marginBottom: '16px' }}>
              <span>
                {selectedType === 'preAdm' ? 'São as roteirizações realizadas para os funcionários que ainda serão admitidos.' : 'São as roteirizações realizadas para os funcionários que já estão admitidos, e já recebem um VT.'}
              </span>
            </div>
            <SearchesTypes
              setSearchByCpfModalShow={setSearchByCpfModalShow}
              setSearchByCodeModalShow={setSearchByCodeModalShow}
              setSearchByNameModalShow={setSearchByNameModalShow}
              setSearchByRegistrationModalShow={setSearchByRegistrationModalShow}
              setSearchByPeriodModalShow={setSearchByPeriodModalShow}
              setSearchByWorkplaceModalShow={setSearchByWorkplaceModalShow}
              setSearchByFileModalShow={setSearchByFileModalShow}
            />

            {hasConsults && (
              <>
                <Filters
                  routingStatus={routingStatus}
                  routingStatusOptions={routingStatusOptions}
                  setRoutingStatus={setRoutingStatus}
                  consultStatus={consultStatus}
                  consultStatusOptions={consultStatusOptions}
                  setConsultStatus={setConsultStatus}
                />

              </>
            )}

            <ListHeader
              doesListExists={hasConsults}
              filteredListLength={filteredListLength}
              singularLabel="Consulta"
              pluralLabel="Consultas"
              searchLabel={searchLabel}
              pagesQuantity={pagesQuantity}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              isSelectingConsults={isSelectingConsults}
              setIsSelectingConsults={setIsSelectingConsults}
              clearAllSelectedConsults={clearAllSelectedConsults}
              addAllSelectedConsults={addAllSelectedConsults}
              setActionModalShow={setActionModalShow}
              isSomeConsultSelected={selectedConsults.length > 0}
              setRemoveFileModalShow={setRemoveFileModalShow}
              isFileSearch={isFileSearch}
              hasOpenedRequest={hasOpenedRequest}
              setSendEmailsModalShow={setSendEmailsModalShow}
              selectedType={selectedType}
            />

            {hasConsults && (
              <>
                <FilterRadioButtonsContainer>
                  <FilterRadioButton selected={listView === 'card'} onClick={() => setListView('card')}>
                        Cards
                  </FilterRadioButton>
                  <FilterRadioButton selected={listView === 'table'} onClick={() => setListView('table')}>
                        Tabela
                  </FilterRadioButton>
                </FilterRadioButtonsContainer>

                {listView === 'card' ? (
                  <OpacityAnimation delay={0.2}>
                    <ConsultsList
                      filteredConsults={filteredConsults}
                      isSelectingConsults={isSelectingConsults}
                      selectedConsults={selectedConsults}
                      handleConsultSelection={handleConsultSelection}
                      selectedType={selectedType}
                    />
                  </OpacityAnimation>
                ): (
                  <OpacityAnimation delay={0.2}>
                    <TableView
                      filteredConsults={filteredConsults}
                      isSelectingConsults={isSelectingConsults}
                      selectedConsults={selectedConsults}
                      handleConsultSelection={handleConsultSelection}
                      selectedType={selectedType}
                    />
                  </OpacityAnimation>
                )}
              </>
            )}

            {!hasConsults && (
              <NoData
                icon="searchNotFound"
                label={(
                  <>
                    Realize a pesquisa de consultas por algum método acima.
                  </>
                )}
              />
            )}

            <SearchByCpfModal
              searchByCpf={searchByCpf}
              searchByCpfModalShow={searchByCpfModalShow}
              setSearchByCpfModalShow={setSearchByCpfModalShow}
            />

            <SearchByCodeModal
              searchByCodeModalShow={searchByCodeModalShow}
              setSearchByCodeModalShow={setSearchByCodeModalShow}
              searchByCode={searchByCode}
            />

            <SearchByNameModal
              searchByName={searchByName}
              searchByNameModalShow={searchByNameModalShow}
              setSearchByNameModalShow={setSearchByNameModalShow}
            />

            <SearchByRegistrationModal
              searchByRegistration={searchByRegistration}
              searchByRegistrationModalShow={searchByRegistrationModalShow}
              setSearchByRegistrationModalShow={setSearchByRegistrationModalShow}
            />

            <SearchByPeriodModal
              searchByPeriodModalShow={searchByPeriodModalShow}
              setSearchByPeriodModalShow={setSearchByPeriodModalShow}
              searchByPeriod={searchByPeriod}
            />

            <SearchByWorkplaceModal
              searchByWorkplaceModalShow={searchByWorkplaceModalShow}
              setSearchByWorkplaceModalShow={setSearchByWorkplaceModalShow}
              searchByWorkplace={searchByWorkplace}
              workplacesOptions={workplacesOptions}
            />

            <SearchByFileModal
              searchByFileModalShow={searchByFileModalShow}
              setSearchByFileModalShow={setSearchByFileModalShow}
              searchByFile={searchByFile}
              fileOptions={filesOptions}
              loadListsForSearching={loadListsForSearching}
            />

            <ActionsModal
              actionModalShow={actionModalShow}
              setActionModalShow={setActionModalShow}
              selectedAction={selectedAction}
              setSelectedAction={setSelectedAction}
              confirmAction={confirmAction}
              emailSendZip={emailSendZip}
              handleEmailSendZipChange={handleEmailSendZipChange}
            />

            <RemoveFileModal
              removeFileModalShow={removeFileModalShow}
              setRemoveFileModalShow={setRemoveFileModalShow}
              removeFile={removeFile}
            />

            <SendEmailsModal
              sendEmailsModalShow={sendEmailsModalShow}
              setSendEmailsModalShow={setSendEmailsModalShow}
              sendEmails={sendEmails}
            />
          </>
        )}
      </Transitions>
    </>
  );
}
